<template>
  <div class="ai-chat-container">
    <!-- 欢迎、聊天和历史记录共用一个标题栏。 -->
    <div class="chat-header">
      <div class="header-title">ICE<span>Chat</span></div>
      <div class="header-actions">
        <el-tooltip :content="$t('index.li_shi_dui_hua')" placement="bottom">
          <button type="button" class="action-btn" :class="{ active: showHistory }" :aria-label="$t('index.li_shi_dui_hua')" :aria-pressed="showHistory" @click="toggleHistory">
            <i class="icon icon-qingsaoshijian" aria-hidden="true"></i>
          </button>
        </el-tooltip>
        <el-tooltip v-if="showWindow" :content="expanded ? $t('index.huan_yuan_chuang_kou') : $t('index.zhan_kai_chuang_kou')" placement="bottom">
          <button type="button" class="action-btn" :aria-label="expanded ? $t('index.huan_yuan_chuang_kou') : $t('index.zhan_kai_chuang_kou')" @click="$emit('new-window')">
            <i class="icon icon-zhankai1" aria-hidden="true"></i>
          </button>
        </el-tooltip>
        <el-tooltip :content="$t('index.xin_jian_dui_hua')" placement="bottom">
          <button type="button" class="action-btn" :disabled="isStreaming" :aria-label="$t('index.xin_jian_dui_hua')" @click="clearMessages">
            <i class="icon icon-xinjian" aria-hidden="true"></i>
          </button>
        </el-tooltip>
        <el-tooltip v-if="showClose" :content="$t('Common.com_close')" placement="bottom">
          <button type="button" class="action-btn" :aria-label="$t('Common.com_close')" @click="$emit('close')">
            <i class="icon icon-guanbi2" aria-hidden="true"></i>
          </button>
        </el-tooltip>
      </div>
    </div>

    <div v-if="showHistory" class="history-view">
      <el-input v-model="historyKeyword" class="history-search" prefix-icon="el-icon-search" :placeholder="$t('index.sou_suo')" :aria-label="$t('index.sou_suo')" clearable />
      <div class="history-heading">
        <span>{{ $t('index.li_shi_dui_hua') }}</span>
        <el-tooltip :content="$t('index.qklsdh')" placement="bottom">
          <button type="button" class="action-btn history-clear" :disabled="!sessions.length || isStreaming" :aria-label="$t('index.qklsdh')" @click="clearHistory">
            <i class="el-icon-delete"></i>
          </button>
        </el-tooltip>
      </div>
      <div class="history-list">
        <div v-for="session in filteredSessions" :key="session.id" class="history-row" :class="{ active: session.id === activeSessionId }">
          <button type="button" class="history-item" :disabled="isStreaming" @click="selectSession(session)">
            <span>{{ session.title }}</span>
          </button>
          <el-dropdown trigger="click" @command="deleteSession(session)">
            <button type="button" class="action-btn history-more" :disabled="isStreaming" :aria-label="$t('Common.com_more_action')">
              <span class="more-dots" aria-hidden="true"><i></i><i></i><i></i></span>
            </button>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item command="delete" icon="el-icon-delete">{{ $t('Common.com_delete') }}</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
        <!-- 拉取后端对话列表时展示加载动画 -->
        <div v-if="historyLoading" class="history-loading" role="status" aria-live="polite">
          <span class="loading-dots" aria-hidden="true"><i></i><i></i><i></i></span>
          <span>{{ $t('index.zzjzlsdh') }}</span>
        </div>
        <div v-else class="history-empty">{{ historyKeyword && !filteredSessions.length ? $t('index.myzdxgdh') : $t('index.mygdsjl') }}</div>
      </div>
    </div>

    <template v-else>
      <div ref="messageList" class="message-list">
        <div v-if="!messages.length && !messageLoading" class="empty-state">
          <div class="welcome-section">
            <welcome-radar />
            <div class="welcome-title">
              <transition name="welcome-title-fade" mode="out-in">
                <h2 v-if="welcomeTitleIndex === 0" key="product" class="welcome-title__text">
                  {{ $t('index.huan_ying_shi_yong') }} <b>ICE</b><span>Chat</span> {{ $t('index.gong_neng') }}
                </h2>
                <h2 v-else key="assistant" class="welcome-title__text">
                  {{ $t('index.Hirsyxws') }}<span>{{ $t('index.xiao_bang') }}</span>
                </h2>
              </transition>
            </div>
            <p class="welcome-desc"><span>{{ $t('index.wyjrsysdjgtqjsjyywgd') }}</span><span>{{ $t('index.ytAInlfzngddyglmytsb') }}</span></p>
          </div>
          <!-- 猜你想问：暂时没有推荐问题列表，改为接口获取后再放开 -->
          <!-- <div class="suggest-section">
            <div class="suggest-label">猜你想问：</div>
            <div class="suggest-list">
              <button v-for="question in commonQuestions" :key="question" type="button" class="suggest-item" @click="handleSend(question)">
                <i class="icon icon-xiejiantou" aria-hidden="true"></i>
                <span>{{ question }}</span>
              </button>
            </div>
          </div> -->
        </div>
        <message-item v-for="msg in messages" :key="msg.id" :message="msg" @retry="handleRetry" />

        <!-- 切换历史对话后拉取消息时展示加载动画 -->
        <div v-if="messageLoading" class="message-loading" role="status" aria-live="polite">
          <span class="loading-dots" aria-hidden="true"><i></i><i></i><i></i></span>
          <span>{{ $t('index.zzjzlsdh') }}</span>
        </div>

        <!-- 回答完成后展示推荐追问，设计稿：分隔线 + 文案 + 胶囊列表 -->
        <!-- <div v-if="showFollowup" class="followup-section">
          <div class="followup-divider" role="separator">
            <span class="divider-line" aria-hidden="true"></span>
            <span class="divider-text">可以继续问我更多</span>
            <span class="divider-line" aria-hidden="true"></span>
          </div>
          <div class="followup-list">
            <button v-for="question in commonQuestions" :key="question" type="button" class="followup-item" @click="handleSend(question)">
              <i class="icon icon-xiejiantou" aria-hidden="true"></i>
              <span>{{ question }}</span>
            </button>
          </div>
        </div> -->
      </div>

      <div class="bottom-area">
        <input-box
          ref="inputBox"
          v-model="inputText"
          :disabled="isStreaming"
          :is-streaming="isStreaming"
          @send="handleSend"
          @stop="handleStop"
        />
        <div class="disclaimer">{{ $t('index.AIscnrjgckczqysjqkwz') }}</div>
      </div>
    </template>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import sseRequest from '@/utils/sseRequest';
import apis from '@/utils/apis';
import messageItem from './messageItem.vue';
import inputBox from './inputBox.vue';
import welcomeRadar from './welcomeRadar.vue';

export default {
  name: 'AiChatIndex',
  components: { messageItem, inputBox, welcomeRadar },
  props: {
    sessionId: { type: String, default: null },
    autoContext: { type: Boolean, default: false },
    expanded: { type: Boolean, default: false },
    showWindow: { type: Boolean, default: true },
    showClose: { type: Boolean, default: true },
    // 演示页可传入本地模拟函数，业务页面默认沿用原 SSE 请求。
    requestHandler: { type: Function, default: sseRequest },
  },
  data() {
    return {
      inputText: '',
      currentRequest: null,
      showHistory: false,
      historyKeyword: '',
      historyLoading: false, // 是否正在拉取对话列表
      messageLoading: false, // 是否正在拉取某个对话的消息
      welcomeTitleIndex: 0,
      welcomeTitleTimer: null,
    };
  },
  computed: {
    ...mapState({
      messages: state => state.vm.aiChatMessages,
      isStreaming: state => state.vm.aiChatStreaming,
      sessions: state => state.vm.aiChatSessions,
      activeSessionId: state => state.vm.aiChatSessionId,
    }),
    // 推荐问题：暂时清空，后续改为接口获取
    commonQuestions() {
      // return ['当前有多少台扫地机在运行', '昨天故障率最高的机型是什么', '本周清洁面积排名前三的设备', '耗材库存低于警戒线的设备列表'];
      return [];
    },
    // 最后一条 AI 回答完成后显示推荐追问，流式输出中隐藏
    showFollowup() {
      const last = this.messages[this.messages.length - 1];
      return !this.isStreaming && !!last && last.role === 'assistant' && !!last.content && last.status === 'done';
    },
    filteredSessions() {
      const keyword = this.historyKeyword.trim().toLowerCase();
      return this.sessions.filter(session => (session.title || '').toLowerCase().includes(keyword));
    },
  },
  watch: {
    messages: {
      handler() {
        this.$nextTick(this.scrollToBottom);
      },
      deep: true,
    },
  },
  mounted() {
    this.scrollToBottom();
    // 欢迎标题轮播只在欢迎区可见时提供轻量的视觉反馈。
    this.welcomeTitleTimer = setInterval(() => {
      this.welcomeTitleIndex = (this.welcomeTitleIndex + 1) % 2;
    }, 3000);
    this.Bus.$on('aiChatStop', this.stopCurrentRequest);
  },
  beforeDestroy() {
    this.stopCurrentRequest();
    if (this.welcomeTitleTimer) {
      clearInterval(this.welcomeTitleTimer);
    }
    this.Bus.$off('aiChatStop', this.stopCurrentRequest);
  },
  methods: {
    handleSend(text, retryMessage = null) {
      text = (text || '').trim();
      if (!text || this.isStreaming) {
        return;
      }
      this.showHistory = false;
      if (!this.activeSessionId) {
        this.$store.commit('AI_CHAT_SESSION_ID', `session-${Date.now()}`);
      }
      const lastMessage = this.messages[this.messages.length - 1];
      const replaceLastMessage = retryMessage && lastMessage && lastMessage.id === retryMessage.id;
      if (!replaceLastMessage) {
        this.$store.commit('AI_CHAT_ADD_MESSAGE', {
          id: `user-${Date.now()}`, role: 'user', content: text, status: 'done', timestamp: Date.now(),
        });
        this.$store.commit('AI_CHAT_ADD_MESSAGE', {
          id: `assistant-${Date.now()}`, role: 'assistant', content: '', reasoning: '', progress: '', progressList: [], msgId: '', status: 'sending', error: '', timestamp: Date.now(),
        });
      } else {
        // 重试会生成新的后端消息，清空旧的 msgId，等本次 [DONE] 返回后再回填
        this.$store.commit('AI_CHAT_UPDATE_LAST_MESSAGE', { content: '', reasoning: '', progress: '', progressList: [], msgId: '', status: 'sending', error: '' });
      }
      if (!retryMessage) {
        this.inputText = '';
      }
      this.$store.commit('AI_CHAT_STREAMING', true);
      this.saveSession();
      // 回调只更新本次请求对应的消息，防止切换会话后写入其他对话。
      const messageId = this.messages[this.messages.length - 1].id;
      // 本地临时会话 ID（session-开头）不传给后端，由后端自动创建新会话；
      // 接口在流结束时通过 [DONE]:会话ID 返回真实会话 ID
      const isTempSession = !this.activeSessionId || String(this.activeSessionId).startsWith('session-');
      // 优先使用接口返回的会话 ID，页面传入的 sessionId 仅作为初始值
      const requestSessionId = this.sessionId || (isTempSession ? null : this.activeSessionId);
      this.currentRequest = this.requestHandler(apis.AiChatStream, {
        content: text, // 用户问题（必填）
        sessionId: requestSessionId, // 会话 ID（可选，不传则自动创建新会话）
      }, {
        onChunk: (data) => {
          if (this.isCurrentMessage(messageId)) {
            this.handleStreamChunk(data);
          }
        },
        onDone: () => {
          if (this.isCurrentMessage(messageId)) {
            this.finishStream();
          }
        },
        onError: (error) => {
          if (this.isCurrentMessage(messageId)) {
            this.finishStream(error);
          }
        },
      });
    },
    isCurrentMessage(id) {
      const message = this.messages[this.messages.length - 1];
      return this.isStreaming && message && message.id === id;
    },
    handleStreamChunk(data) {
      const message = this.messages[this.messages.length - 1];
      if (data.type === 'delta' && data.content) {
        this.$store.commit('AI_CHAT_UPDATE_LAST_MESSAGE', { content: message.content + data.content });
      } else if (data.type === 'reasoning' && data.content) {
        this.$store.commit('AI_CHAT_UPDATE_LAST_MESSAGE', { reasoning: (message.reasoning || '') + data.content });
      } else if (data.type === 'progress' && data.content) {
        // 接口返回的处理进度（如：正在分析您的问题...），按顺序累积成列表
        const previous = (message.progressList || []).map(item => ({ ...item, done: true }));
        // 同一条进度重复推送时只更新，避免列表出现重复项
        if (previous.length && previous[previous.length - 1].text === data.content) {
          return;
        }
        this.$store.commit('AI_CHAT_UPDATE_LAST_MESSAGE', {
          progress: data.content,
          progressList: [...previous, { text: data.content, done: false }],
        });
      } else if (data.type === 'done') {
        // 记录流结束事件返回的会话 ID，后续请求继续该会话上下文
        if (data.sessionId) {
          this.applyStreamSessionId(data.sessionId);
        }
        // 记录本次回答的消息 ID（[DONE]:会话ID,消息ID），点赞/点踩反馈需要用到
        if (data.msgId) {
          this.$store.commit('AI_CHAT_UPDATE_LAST_MESSAGE', { msgId: String(data.msgId) });
        }
      }
    },
    // 将接口返回的会话 ID 应用到本次会话，并替换首次对话使用的本地临时 ID
    applyStreamSessionId(sessionId) {
      const currentSession = this.sessions.find(item => item.id === this.activeSessionId && item.id.startsWith('session-'));
      if (currentSession) {
        const sessions = [{ ...currentSession, id: sessionId }, ...this.sessions.filter(item => item.id !== currentSession.id)];
        this.$store.commit('AI_CHAT_SESSIONS', sessions);
      }
      this.$store.commit('AI_CHAT_SESSION_ID', sessionId);
    },
    finishStream(error, status = 'done') {
      this.$store.commit('AI_CHAT_STREAMING', false);
      this.$store.commit('AI_CHAT_UPDATE_LAST_MESSAGE', {
        status: error ? 'error' : status,
        error: error ? error.message || this.$t('index.qing_qiu_shi_bai') : '',
      });
      if (this.currentRequest) {
        this.currentRequest.abort();
      }
      this.currentRequest = null;
      this.saveSession();
    },
    handleStop() {
      // 独立页面和浮窗共享消息，由持有请求的组件负责中断。
      this.Bus.$emit('aiChatStop');
    },
    stopCurrentRequest() {
      if (this.currentRequest) {
        this.finishStream(null, 'stopped');
      }
    },
    handleRetry(message) {
      if (this.isStreaming) {
        return;
      }
      const index = this.messages.findIndex(item => item.id === message.id);
      const question = this.messages[index - 1];
      if (question && question.role === 'user') {
        this.handleSend(question.content, message);
      }
    },
    scrollToBottom() {
      const container = this.$refs.messageList;
      if (container) {
        container.scrollTop = this.messages.length ? container.scrollHeight : 0;
      }
    },
    // 历史会话暂存于 Vuex，刷新页面后清空，不写入浏览器持久化存储。
    saveSession() {
      const question = this.messages.find(message => message.role === 'user');
      if (!question || !this.activeSessionId) {
        return;
      }
      const session = {
        id: this.activeSessionId,
        title: question.content,
        messages: this.messages.map(message => ({ ...message })),
      };
      this.$store.commit('AI_CHAT_SESSIONS', [session, ...this.sessions.filter(item => item.id !== session.id)]);
    },
    toggleHistory() {
      this.saveSession();
      this.showHistory = !this.showHistory;
      this.historyKeyword = '';
      if (this.showHistory) {
        // 打开历史记录时拉取后端对话列表
        this.fetchSessions();
      } else {
        this.$nextTick(this.scrollToBottom);
      }
    },
    // 查询当前登录用户的对话列表（接口按更新时间倒序返回）
    fetchSessions() {
      // 演示入口未注入 $getJSON，直接沿用本地会话
      if (!this.$getJSON) {
        return;
      }
      this.historyLoading = true;
      this.$getJSON(apis.AiChatSessions).then((res) => {
        this.applySessionList(res.data);
      }).catch((err) => {
        // 后端成功码若未统一为 0，axios 拦截器会判为失败并 reject，这里补取 data
        this.applySessionList(err ? err.data : null);
      }).finally(() => {
        this.historyLoading = false;
      });
    },
    // 渲染后端对话列表，并合并本地会话
    applySessionList(list) {
      this.$store.commit('AI_CHAT_SESSIONS', this.formatSessionList(Array.isArray(list) ? list : []));
    },
    // 后端字段转换为历史列表结构，messages 沿用本地缓存，避免切换会话时丢失当前对话
    formatSessionList(list) {
      const localSessions = this.sessions || [];
      const localMap = {};
      localSessions.forEach((session) => {
        localMap[String(session.id)] = session;
      });
      const sessions = list
        .filter(item => item && item.isDelete !== 1) // 只过滤手动删除的对话
        .map((item) => {
          const id = String(item.sessionId);
          const local = localMap[id];
          return {
            id,
            title: item.sessionTitle || (local && local.title) || this.$t('index.xin_jian_dui_hua'),
            messages: (local && local.messages) || [],
          };
        });
      // 保留尚未同步到后端的本地临时会话
      localSessions.forEach((session) => {
        if (String(session.id).startsWith('session-')) {
          sessions.unshift(session);
        }
      });
      return sessions;
    },
    selectSession(session) {
      if (this.isStreaming) {
        return;
      }
      this.saveSession();
      this.$store.commit('AI_CHAT_SESSION_ID', session.id);
      this.showHistory = false;
      this.inputText = '';
      // 本地已有消息缓存时直接展示，否则拉取后端该对话的消息列表
      if (session.messages && session.messages.length) {
        this.$store.commit('AI_CHAT_MESSAGES', session.messages.map(message => ({ ...message })));
        return;
      }
      this.$store.commit('AI_CHAT_MESSAGES', []);
      this.loadSessionMessages(session.id);
    },
    // 查询指定对话的消息列表（接口按创建时间正序返回）
    loadSessionMessages(sessionId) {
      // 演示入口未注入 $getJSON，无法拉取历史消息
      if (!this.$getJSON) {
        return;
      }
      this.messageLoading = true;
      this.$getJSON(apis.AiChatMessages, { sessionId }).then((res) => {
        this.applySessionMessages(sessionId, res.data);
      }).catch((err) => {
        // 后端成功码若未统一为 0，axios 拦截器会判为失败并 reject，这里补取 data
        this.applySessionMessages(sessionId, err ? err.data : null);
      }).finally(() => {
        this.messageLoading = false;
      });
    },
    // 渲染指定对话的历史消息，并缓存到本地会话
    applySessionMessages(sessionId, list) {
      const messages = this.formatMessageList(Array.isArray(list) ? list : []);
      // 加载期间用户可能已切换对话，避免消息串到其他会话
      if (String(this.activeSessionId) !== String(sessionId)) {
        return;
      }
      this.$store.commit('AI_CHAT_MESSAGES', messages);
      this.$store.commit('AI_CHAT_SESSIONS', this.sessions.map(item => (
        String(item.id) === String(sessionId) ? { ...item, messages } : item
      )));
    },
    // 后端消息字段转换为页面消息结构（msgContent 正文、msgRole 角色、msgId 标识）
    formatMessageList(list) {
      return list
        .filter(item => item && item.isDelete !== 1) // 过滤已删除的消息
        .map((item, index) => ({
          id: item.msgId || `history-${index}`,
          role: item.msgRole === 'user' ? 'user' : 'assistant',
          content: item.msgContent || '',
          feedback: item.feedback || 0, // 消息反馈：0-无反馈/1-点赞/2-点踩
          reasoning: '',
          progress: '',
          progressList: [],
          status: 'done',
          timestamp: item.gmtCreate ? new Date(item.gmtCreate).getTime() : Date.now(),
        }));
    },
    clearMessages() {
      if (this.isStreaming) {
        return;
      }
      this.saveSession();
      this.$store.commit('AI_CHAT_MESSAGES', []);
      this.$store.commit('AI_CHAT_SESSION_ID', null);
      this.inputText = '';
      this.showHistory = false;
      this.$nextTick(() => {
        if (this.$refs.inputBox) {
          this.$refs.inputBox.focus();
        }
      });
    },
    clearHistory() {
      if (this.isStreaming) {
        return;
      }
      this.$confirm(this.$t('index.qdqkdqymzdsylsdhm'), this.$t('index.li_shi_dui_hua'), {
        confirmButtonText: this.$t('Common.com_confirm'),
        cancelButtonText: this.$t('Common.com_cancel'),
        type: 'warning',
      }).then(() => {
        if (this.isStreaming) {
          return;
        }
        this.$store.commit('AI_CHAT_SESSIONS', []);
        this.$store.commit('AI_CHAT_MESSAGES', []);
        this.$store.commit('AI_CHAT_SESSION_ID', null);
        this.inputText = '';
      }).catch(() => {});
    },
    // 删除对话（后端会同时删除该对话下所有消息）
    deleteSession(session) {
      if (this.isStreaming) {
        return;
      }
      // 本地临时会话尚未落库，直接删除本地即可
      if (!this.$postJSON || String(session.id).startsWith('session-')) {
        this.removeLocalSession(session);
        return;
      }
      this.$postJSON(`${apis.AiChatDeleteSession}/${session.id}`).then(() => {
        this.removeLocalSession(session);
        this.$message.success(this.$t('Common.com_delete_success'));
      }).catch((err) => {
        // 后端成功码若未统一为 0（如 200），axios 拦截器会 reject，此时删除其实已生效
        if (err && err.code === 200) {
          this.removeLocalSession(session);
          this.$message.success(this.$t('Common.com_delete_success'));
        }
      });
    },
    // 从本地移除对话，并清理相关消息
    removeLocalSession(session) {
      this.$store.commit('AI_CHAT_SESSIONS', this.sessions.filter(item => item.id !== session.id));
      if (this.activeSessionId === session.id) {
        this.$store.commit('AI_CHAT_MESSAGES', []);
        this.$store.commit('AI_CHAT_SESSION_ID', null);
        this.inputText = '';
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.ai-chat-container {
  display: flex;
  flex-direction: column;
  height: 100%;
  min-height: 0;
  overflow: hidden;
  background: #ffffff;
  color: #1f2937;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Microsoft YaHei', Arial, sans-serif;
  letter-spacing: 0;

  button { font: inherit; letter-spacing: 0; }
}

// 标题栏：设计稿 414×62、内边距 15/12、纯白无分隔线
.chat-header {
  display: flex;
  flex: 0 0 62px;
  align-items: center;
  justify-content: space-between;
  height: 62px;
  padding: 15px 12px;
  background: #ffffff;

  // 标题：设计稿为 Microsoft YaHei Bold 20px / 行高 26.4 / 字距 -0.2
  .header-title {
    color: #000311;
    font-family: 'Microsoft YaHei', -apple-system, BlinkMacSystemFont, 'Segoe UI', Arial, sans-serif;
    font-size: 20px;
    font-weight: 700;
    line-height: 26.4px;
    letter-spacing: -0.2px;
  }
  // 设计稿中 “Chat” 为主题蓝 #2563EB
  .header-title span { color: #2563eb; }
  // 设计稿操作区图标间距 8px
  .header-actions { display: flex; align-items: center; gap: 8px; }
}

// 图标按钮：设计稿只有图标本体，不带描边圆圈，这里保留 32×32 点击热区和悬停底色
.action-btn {
  display: inline-flex;
  flex: 0 0 32px;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  padding: 0;
  border: 0;
  border-radius: 50%;
  background: transparent;
  color: #000311;
  cursor: pointer;
  transition: background 0.2s cubic-bezier(0.4, 0, 0.2, 1), color 0.2s cubic-bezier(0.4, 0, 0.2, 1);

  // 四个图标统一用 18px 字号。但字形墨迹在 em 框里的占比不同（历史 1.07em、展开 0.93em、
  // 新建 0.95em、关闭 0.83em；高度方向 0.97 / 0.88 / 0.81 / 0.70em），
  // 只写 18px 的话渲染出来最大的比最小的大 38%，所以再按各自占比缩放，
  // 让四个图标最终渲染的墨迹一样大（等面积，约 17×15）。
  // 缩放系数与位移由 iconfont.ttf 的 glyf 包围盒反推；transform-origin 默认居中，
  // translate 写在 scale 前面，所以位移量就是最终像素值。
  // line-height: 1 让行盒高度恒等于字号，位移数值才成立，不要改成别的行高。
  .icon {
    display: block;
    line-height: 1;
    font-size: 18px;
  }
  // 墨迹占字号 1.0664 × 0.9668
  .icon-shijian { transform: translate(0.13px, 0) scale(0.875); }
  // 墨迹占字号 0.9336 × 0.876
  .icon-zhankai { transform: translate(0.59px, 0) scale(0.983); }
  // 墨迹占字号 0.9453 × 0.8145
  .icon-xinjian { transform: translate(0.5px, 0) scale(1.013); }
  // 墨迹占字号 0.8281 × 0.7031
  .icon-guanbi { transform: translate(1.8px, -0.49px) scale(1.165); }
  &:hover { background: #f5f6fa; color: #333333; }
  &.active { background: #f5f6fa; color: #333333; }
  &:focus-visible {
    outline: 2px solid #3675d8;
    outline-offset: 2px;
  }
  // 生成中按钮只是不可点击，图标保持设计稿色值 #000311，不做整体灰化
  &:disabled { cursor: not-allowed; }
}

.message-list {
  position: relative;
  flex: 1;
  min-height: 0;
  overflow-y: auto;
  overflow-x: hidden;
  padding-top: 16px;
  // 设计稿消息区为纯白背景
  background: #ffffff;
}

// 回答完成后的推荐追问区
.followup-section {
  padding: 0 16px 8px;

  // 设计稿分隔行：左右 1px 细线 + 文字 13px/22 #333333，间距 14
  .followup-divider {
    display: flex;
    align-items: center;
    gap: 14px;
    padding: 10px 0;

    // 设计稿分隔线为渐隐细线：靠近文字一侧为 #848691，外侧透明
    .divider-line {
      flex: 1;
      height: 1px;
      background: linear-gradient(90deg, rgba(132, 134, 145, 0), #848691);

      &:last-child {
        background: linear-gradient(90deg, #848691, rgba(132, 134, 145, 0));
      }
    }
    .divider-text { flex-shrink: 0; color: #333333; font-size: 13px; line-height: 22px; }
  }

  .followup-list { display: flex; flex-direction: column; gap: 6px; }

  // 设计稿推荐项：高 37、全圆角胶囊、底色 #FCFCFD、0.8px 描边（用 1px hairline 落地）
  .followup-item {
    display: flex;
    align-items: center;
    gap: 6px;
    width: 100%;
    min-height: 37px;
    padding: 9px 14px;
    border: 1px solid rgba(0, 0, 0, 0.06);
    border-radius: 999px;
    background: #fcfcfd;
    color: #000311;
    text-align: left;
    font: inherit;
    font-size: 13px;
    line-height: 16.8px;
    cursor: pointer;
    transition: background 0.2s cubic-bezier(0.4, 0, 0.2, 1), border-color 0.2s cubic-bezier(0.4, 0, 0.2, 1);

    // 设计稿箭头图标：16×16 占位框内是 9×9 的墨迹（icon-xiejiantou 墨迹占字号 0.914），色值 #848691
    i {
      display: inline-flex;
      flex-shrink: 0;
      align-items: center;
      justify-content: center;
      width: 16px;
      height: 16px;
      color: #848691;
      font-size: 10px;
    }
    span { min-width: 0; overflow-wrap: anywhere; }

    &:hover {
      background: #f5f6fa;
      border-color: rgba(0, 0, 0, 0.12);
    }
    &:focus-visible {
      outline: 2px solid #3675d8;
      outline-offset: 2px;
    }
  }
}

.empty-state { width: 100%; max-width: 520px; margin: -8px auto 0; padding-bottom: 24px; }

.welcome-title {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 36px;
  margin: 0 16px 18px;
  overflow: hidden;
}

.welcome-title__text {
  margin: 0;
  color: #191c2b;
  text-align: center;
  font-size: 26px;
  font-weight: 700;
  line-height: 36px;
  letter-spacing: -0.02em;
  white-space: nowrap;

  b, span { color: #2563EB; }
  b { color: #191c2b; }
}

.welcome-title-fade-enter-active,
.welcome-title-fade-leave-active { transition: opacity 0.4s ease; }
.welcome-title-fade-enter,
.welcome-title-fade-leave-to { opacity: 0; }

.welcome-desc { margin: 0 32px; color: #8b8c94; font-size: 14px; line-height: 23px; text-align: left; }

.suggest-section {
  padding: 14px 16px 0;

  .suggest-label { margin: 0 16px 10px; color: #73747d; font-size: 13px; line-height: 18px; }
  .suggest-list { display: flex; flex-direction: column; gap: 6px; }

  // 设计稿推荐项：高 37、全圆角胶囊、底色 #FCFCFD、0.8px 描边（用 1px hairline 落地）
  .suggest-item {
    display: flex;
    align-items: center;
    gap: 6px;
    width: 100%;
    min-height: 37px;
    padding: 9px 14px;
    border: 1px solid rgba(0, 0, 0, 0.06);
    border-radius: 999px;
    background: #fcfcfd;
    color: #000311;
    text-align: left;
    font: inherit;
    font-size: 13px;
    line-height: 16.8px;
    cursor: pointer;
    transition: background 0.2s cubic-bezier(0.4, 0, 0.2, 1), border-color 0.2s cubic-bezier(0.4, 0, 0.2, 1);

    // 设计稿箭头图标：16×16 占位框内是 9×9 的墨迹（icon-xiejiantou 墨迹占字号 0.914），色值 #848691
    i {
      display: inline-flex;
      flex-shrink: 0;
      align-items: center;
      justify-content: center;
      width: 16px;
      height: 16px;
      color: #848691;
      font-size: 10px;
    }
    span { min-width: 0; overflow-wrap: anywhere; }
    &:hover {
      background: #f5f6fa;
      border-color: rgba(0, 0, 0, 0.12);
    }
    &:focus-visible {
      outline: 2px solid #3675d8;
      outline-offset: 2px;
    }
  }
}

// 底部输入区：设计稿 414×153，纵向间距 16、内边距 8，无顶部分隔线
.bottom-area {
  display: flex;
  flex-shrink: 0;
  flex-direction: column;
  gap: 16px;
  padding: 8px;
  background: #ffffff;

  .disclaimer {
    color: #b1b2ba;
    font-size: 12px;
    line-height: 16px;
    text-align: center;
  }
}

// 历史对话视图：内容区 padding 8/16，模块间距 10（搜索→标题行）、5（标题行→列表）
.history-view {
  display: flex;
  flex: 1;
  flex-direction: column;
  min-height: 0;
  padding: 8px 16px;

  // 搜索框：设计稿内边距 16 + 图标 16 + 间距 8 = 输入区从 40px 开始
  .history-search ::v-deep .el-input__inner {
    height: 40px;
    padding-left: 40px;
    border: 1px solid rgba(0, 0, 0, 0.08);
    border-radius: 16px;
    background: #fcfcfd;
    color: #333333;
    font-family: 'Microsoft YaHei', -apple-system, BlinkMacSystemFont, 'Segoe UI', Arial, sans-serif;
    font-size: 13px;
    line-height: 22px;
    box-shadow: none;
    transition: border-color 0.2s ease;

    &::placeholder { color: #848691; }
    &:hover, &:focus { border-color: rgba(0, 0, 0, 0.16); }
  }

  // 搜索图标：设计稿 16×16，距左边 16px，色值 #202945
  .history-search ::v-deep .el-input__prefix { left: 16px; }

  .history-search ::v-deep .el-input__icon {
    width: 16px;
    line-height: 40px;
    color: #202945;
    font-size: 16px;
  }

  // 标题行文字：设计稿 13px / 行高 16.8 / 65% 黑
  .history-heading {
    display: flex;
    flex: 0 0 28px;
    align-items: center;
    justify-content: space-between;
    height: 28px;
    margin: 10px 0 5px;
    color: rgba(0, 0, 0, 0.65);
    font-size: 13px;
    line-height: 16.8px;
  }

  // 清空按钮按设计稿为纯图标 28×28，不带圆形描边
  .history-clear {
    flex: 0 0 28px;
    width: 28px;
    height: 28px;
    border: 0;
    border-radius: 0;
    background: transparent;
    color: #585858;

    i { font-size: 16px; }
    &:hover { background: transparent; color: #333333; }
  }

  .history-list { flex: 1; min-height: 0; overflow-y: auto; }

  // 会话行：设计稿 44 高、圆角 8、gap 10、padding 8/10，选中/悬停底色 #F5F6FA
  .history-row {
    display: flex;
    align-items: center;
    gap: 10px;
    min-height: 44px;
    padding: 8px 10px;
    border-radius: 8px;
    transition: background 0.2s ease;

    // 更多按钮：设计稿 28×28 圆形，描边为透明（仅占位，不显示）
    .history-more {
      flex: 0 0 28px;
      width: 28px;
      height: 28px;
      border-color: transparent;
      opacity: 0;
      transition: opacity 0.2s ease;
    }

    // 三点图标：设计稿为 3×3px 圆点、间距 3.5px（总宽 16px）、色值 #333333
    .more-dots {
      display: inline-flex;
      align-items: center;
      gap: 3.5px;

      i {
        width: 3px;
        height: 3px;
        border-radius: 50%;
        background: #333333;
      }
    }
    &:hover, &:focus-within, &.active { background: #f5f6fa; }
    &:hover .history-more, &:focus-within .history-more, &.active .history-more { opacity: 1; }
    // 选中态：设计稿为 #333333 + 700 字重
    &.active .history-item { color: #333333; font-weight: 700; }
  }

  // 会话标题文字：设计稿 14px / 行高 19.2 / #333333，选中态 700 字重
  .history-item {
    display: flex;
    flex: 1;
    align-self: stretch;
    align-items: center;
    min-width: 0;
    padding: 0;
    border: 0;
    background: transparent;
    color: #333333;
    text-align: left;
    font-size: 14px;
    line-height: 19.2px;
    cursor: pointer;

    span { display: block; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
    &:hover { background: transparent; }
    &:focus-visible { outline: 2px solid #3675d8; outline-offset: -2px; }
    &:disabled { opacity: 0.5; cursor: not-allowed; }
  }

  // 底部“没有更多数据了”：设计稿 42 高、上间距 5、padding 10、13px #848691 居中
  .history-empty {
    display: flex;
    align-items: center;
    justify-content: center;
    min-height: 42px;
    margin-top: 5px;
    padding: 10px;
    color: #848691;
    font-size: 13px;
    line-height: 22px;
    text-align: center;
  }

  // 加载中：沿用空状态的高度与文字样式，把文案换成跳动圆点
  .history-loading {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    min-height: 42px;
    margin-top: 5px;
    padding: 10px;
    color: #848691;
    font-size: 13px;
    line-height: 22px;
  }
}

// 消息区加载中：居中展示，等待历史消息返回
.message-loading {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 24px 16px;
  color: #848691;
  font-size: 13px;
  line-height: 22px;
}

// 加载动画：三个圆点依次跳动，与消息打字动画保持一致的节奏
.loading-dots {
  display: inline-flex;
  align-items: center;
  gap: 5px;

  i {
    width: 5px;
    height: 5px;
    border-radius: 50%;
    background: #2563eb;
    animation: ai-chat-loading-dot 1.2s ease-in-out infinite;

    &:nth-child(2) { animation-delay: 0.15s; }
    &:nth-child(3) { animation-delay: 0.3s; }
  }
}

@keyframes ai-chat-loading-dot {
  0%, 60%, 100% { opacity: 0.3; transform: translateY(0); }
  30% { opacity: 1; transform: translateY(-3px); }
}

@media (prefers-reduced-motion: reduce) {
  .loading-dots i { animation: none; }
}

.message-list, .history-list {
  &::-webkit-scrollbar { width: 4px; }
  &::-webkit-scrollbar-thumb { border-radius: 2px; background: #dedee3; }
}

@media (max-height: 800px) {
  .welcome-title { margin-bottom: 12px; }
}

@media (max-width: 420px) {
  .welcome-title__text { font-size: 22px; }
  .welcome-desc { margin-right: 24px; margin-left: 24px; }
  .chat-header .header-actions { gap: 4px; }
}
</style>
